import { useNavigate } from "react-router-dom";
import { Hero } from "@/components/landing/Hero";
import { Approccio, Metodo, Staff, Perche, Closing } from "@/components/landing/Sections";
import { ConditionsGrid, HomeAreas, TecnologieTeaser, DoctorTeaser, ApprofondimentiTeaser, StartHereCta } from "@/components/landing/HomeSections";

export default function Landing() {
  const navigate = useNavigate();
  const book = () => navigate("/contatti");
  return (
    <>
      <Hero onBook={book} />
      <Approccio />
      <ConditionsGrid />
      <StartHereCta />
      <HomeAreas />
      <Metodo />
      <TecnologieTeaser />
      <DoctorTeaser />
      <Staff />
      <Perche />
      <ApprofondimentiTeaser />
      <Closing onBook={book} />
    </>
  );
}
